import "./MainText.css"
function MainText() {
    return (
        <div className="textMain sm:text-4xl">
            Performance & Appraisal Portal
        </div>
    )
}

export default MainText;